import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import latestNewsData from '../data/latestNewsData';
import NavbarM from '../components/Navbar';
import Footer from '../components/Footer';
import FadeIn from '../components/FadeIn';
import mainLogo from '../img/mainLogo.svg';

const LatestNewsPage = () => {
    const [scroll, setScroll] = useState(false);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        const handleScroll = () => setScroll(window.scrollY > 100);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <>
            <div className='heroMain'>
                <div className={`heroSec heroSec--inner ${scroll ? 'heroSec__' : ''}`}>
                    <NavbarM logo={mainLogo} setNewsPage={() => {}} />
                </div>
                <div className='container' style={{ paddingTop: '150px', paddingBottom: '60px', borderRadius: '30px' }}>
                    <FadeIn direction='up'>
                        <h1 className='latestNewsPage__title text-center'>Latest News</h1>
                    </FadeIn>
                    <div className='latestNewsPage__list'>
                        {latestNewsData.map((item, index) => {
                            const isPdf = item.link && item.link.toLowerCase().endsWith('.pdf');
                            const isInternal = item.link && item.link.startsWith('/') && !isPdf;
        
                            const CardWrapper = ({ children }) => {
                                if (!item.link) return <article className='latestNewsPage__item'>{children}</article>;
                                if (isInternal) return <Link to={item.link} className='latestNewsPage__item'>{children}</Link>;
                                return <a href={item.link} target='_blank' rel='noreferrer' className='latestNewsPage__item'>{children}</a>;
                            };

                            return (
                                <FadeIn key={index} direction='up' delay={index * 80}>
                                    <CardWrapper>
                                        <div className='latestNewsPage__itemImg'>
                                            <img src={item.img} alt={item.title} style={item.imgStyle || {}} />
                                        </div>
                                        <div className='latestNewsPage__itemBody'>
                                            <span className='latestNewsPage__date'>{item.date}</span>
                                            <h2 className='latestNewsPage__itemTitle'>{item.title}</h2>
                                            <p className='latestNewsPage__itemDesc'>{item.description}</p>
                                        </div>
                                    </CardWrapper>
                                </FadeIn>
                            );
                        })}
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default LatestNewsPage;
